// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { FormState, formStateHasField } from "@hex-insights/forms";
import { AnnouncementFilterInput } from "../../../Utilities";
import * as AnnouncementFilterFormValues from "./form-values";
import * as CustomFilterFormUtils from "./utils-custom";

/**
 * Counts the number of active filters for the Announcement model.
 *
 * @param formValues The form values of the filter form.
 */
export function countActiveFilters<
	K extends keyof AnnouncementFilterFormValues.FilterFormValues = keyof AnnouncementFilterFormValues.FilterFormValues,
>(formValues: Pick<AnnouncementFilterFormValues.FilterFormValues, K>) {
	const numStandardFilters = CustomFilterFormUtils.countActiveStandardFilters(formValues);
	const numAdvancedFilters = IndexForms.countActiveAdvancedFilters(
		formValues,
		AnnouncementFilterFormValues.advancedFilterInformation.fieldComparisonTranslations,
	);
	return numStandardFilters + numAdvancedFilters;
}

/**
 * Clears the values of the filter form for the Announcement model.
 *
 * @param formState The form state of the filter form.
 */
export function clearFilters<
	K extends keyof AnnouncementFilterFormValues.FilterFormValues = keyof AnnouncementFilterFormValues.FilterFormValues,
>(formState: FormState<Pick<AnnouncementFilterFormValues.FilterFormValues, K>>) {
	CustomFilterFormUtils.clearStandardFilters(formState);

	if (formStateHasField(formState, "filterSets")) {
		formState.formClearFunctions.filterSets();
	}
}

/**
 * Resets the values of the filter form to the default values (rather than initial since initial may be set by the query
 * string) for the Announcement model.
 *
 * @param formState The form state of the filter form.
 */
export function resetFilters<
	K extends keyof AnnouncementFilterFormValues.FilterFormValues = keyof AnnouncementFilterFormValues.FilterFormValues,
>(formState: FormState<Pick<AnnouncementFilterFormValues.FilterFormValues, K>>) {
	const initial = AnnouncementFilterFormValues.getInitial();

	CustomFilterFormUtils.resetStandardFilters(formState, initial);

	if (formStateHasField(formState, "filterSets")) {
		formState.formSetFunctions.filterSets(initial.filterSets);
	}
}

/**
 * Converts the form values of the filter form for the Announcement model to the correct GraphQL
 * filter input type.
 *
 * @param formValues The form values of the filter form.
 */
export function toFilterInputs<
	K extends keyof AnnouncementFilterFormValues.FilterFormValues = keyof AnnouncementFilterFormValues.FilterFormValues,
>(formValues: Pick<AnnouncementFilterFormValues.FilterFormValues, K>): AnnouncementFilterInput {
	const preparedFormValues = CustomFilterFormUtils.prepareFormValuesForConversion(formValues);
	const filterInput = IndexForms.toFilterInput(
		preparedFormValues,
		AnnouncementFilterFormValues.advancedFilterInformation.fieldComparisonTranslations,
	) as AnnouncementFilterInput;
	return CustomFilterFormUtils.toFilterInputs(formValues, filterInput);
}
